// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu_menu__zfFwe","menuContainer":"Menu_menuContainer__n_p93","mainMenuList":"Menu_mainMenuList__FJ9dl"};